import { getStaticPropsGenerator } from '@cinch-nx/landing-feature-articles-sub-hub'

const path = 'guides/electric-cars'
const resultsPerPage = 10

export const getStaticProps = getStaticPropsGenerator({
  subHubPath: path,
  resultsPerPage,
  breadCrumbs: [
    { text: 'Home', url: '/' },
    { text: 'Guides', url: '/guides' },
    { text: 'Electric cars', url: `/${path}` },
  ],
})

export { ArticleSubHubFeature as default } from '@cinch-nx/landing-feature-articles-sub-hub'
